import React, { useMemo } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Input from 'components/lib/Input';
import { CommunityType } from 'types/communities';

import ShopRequestPropagateModalContentListEmpty from './ShopRequestPropagateModalContentListEmpty';
import ShopRequestPropagateModalContentListItem from './ShopRequestPropagateModalContentListItem';
import { SHOP_REQUEST_PROPAGATION_MODAL_MODE } from '../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Subtitle = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  border-bottom: 1px solid var(--line-gray);
`;

const Title = styled.div`
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Details = styled.div`
  font-size: 12px;
  padding-top: 10px;
  color: var(--text-secondary);
`;

const Search = styled.div`
  padding: 10px 0px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  height: 200px;
  gap: 10px;
  padding: 15px 30px;
  overflow-y: auto;
`;

type Props = {
  mode: number;
  baseCommunityId?: number;
  subtitle?: React.ReactNode;
  communities: CommunityType[];
};

const ShopRequestPropagateModalContent = ({ mode, subtitle, baseCommunityId, communities }: Props) => {
  const [search, setSearch] = React.useState<string>('');

  return (
    <Container>
      <Info>
        <Subtitle>{subtitle}</Subtitle>

        {mode === SHOP_REQUEST_PROPAGATION_MODAL_MODE.APPROVE && <Title>Propagate To ({communities.length})</Title>}
        <Details>
          {mode == SHOP_REQUEST_PROPAGATION_MODAL_MODE.PREVIEW && (
            <span>On shop approval, data will propagate to the communities listed below:</span>
          )}
          {mode == SHOP_REQUEST_PROPAGATION_MODAL_MODE.APPROVE && (
            <span>Please note that the approved data will be propagated to the communities listed below.</span>
          )}
        </Details>
        <Search>
          <Input
            prefix={<SearchOutlined />}
            value={search}
            onChange={(event: any) => setSearch(event.target.value)}
            placeholder="Search communities"
          />
        </Search>
      </Info>
      <List>
        {!communities.length && <ShopRequestPropagateModalContentListEmpty />}
        {communities.length > 0 && (
          <>
            {communities
              .filter((item: CommunityType) => {
                const keyword = search.toLowerCase();
                return (
                  item.comunity_name?.toLowerCase().includes(keyword) ||
                  item.company?.name?.toLowerCase().includes(keyword)
                );
              })
              .sort((a, b) => {
                if (a.id === baseCommunityId) return -1;
                if (b.id === baseCommunityId) return 1;
                return a.company?.name?.localeCompare(b.company?.name ?? '') ?? 0;
              })
              .map((item: CommunityType) => (
                <ShopRequestPropagateModalContentListItem
                  key={item.id}
                  community={item}
                  isBaseCommunity={item.id == baseCommunityId}
                />
              ))}
          </>
        )}
      </List>
    </Container>
  );
};

export default ShopRequestPropagateModalContent;
